import { Modal } from 'reactstrap';
import SimpleCardTable from '../SimpleCardTable';

interface Props {
  key?: string;
  isOpen: boolean;
  onToggle: () => void;
  title: string;
  cardHeader: string[];
  rows: RowItem[];
  striped?: boolean;
  hover?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}

export interface RowItem {
  specialRow?: boolean;
  coloredRow?: string;
  rows: (string | React.ReactElement)[];
}

const TableModal = ({
  cardHeader,
  isOpen,
  onToggle,
  rows,
  title,
  key,
  striped,
  hover,
  size = 'sm',
}: Props) => {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
      size={size}
    >
      <SimpleCardTable
        cardHeader={cardHeader}
        rows={rows}
        title={title}
        key={key}
        hover={hover}
        striped={striped}
      />
    </Modal>
  );
};

export default TableModal;
